"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeQuestionFromParent = void 0;
const processDB_1 = require("./processDB");
function removeQuestionFromParent(db, q) {
    const list = db.lists[q.parentListId];
    const index = list.childQIds.findIndex(c => c === q.qId);
    list.childQIds.splice(index, 1);
    // Fix for the case where we have normal questions
    // mixed in with QSets in the same section. But this
    // should be a problem even otherwise too.
    // In any case, once a question is deleted, we need to
    // reset the ids back to their locations in the array.
    for (let i = index; i < list.childQIds.length; i++) {
        const childQId = list.childQIds[i];
        const childQ = db.questions[childQId];
        childQ.parentListIdx = i;
    }
    (0, processDB_1.processListParent)(db, list, true);
}
exports.removeQuestionFromParent = removeQuestionFromParent;
exports.default = removeQuestionFromParent;
